<script>
import PartnersAnalytics from "@/components/MultiConnect/Analytics/PartnersAnalytics.vue";
import AttendeeAnalytics from "@/components/MultiConnect/Analytics/AttendeeAnalytics.vue";
import SubEventAnalytics from "@/components/MultiConnect/SubEventAnalytics.vue";
import ConnectionsAnalytics from "@/components/MultiConnect/Analytics/ConnectionsAnalytics.vue";
import MetricCard from "@/components/SuperUser/MetricCard.vue";
import NotesAnalytics from "@/components/MultiConnect/Analytics/NotesAnalytics.vue";
import MeetingsAnalytics from "@/components/MultiConnect/Analytics/MeetingsAnalytics.vue";
import AttendeeEventPreferences from "@/components/MultiConnect/Analytics/AttendeeEventPreferences.vue";
import PostAnalytics from "@/components/MultiConnect/Analytics/PostAnalytics.vue";
import MessagingAnalytics from "@/components/MultiConnect/Analytics/MessagingAnalytics.vue";
import {mapGetters} from "vuex";


export default {
  name: "AnalyticsData",
  components: {
    MessagingAnalytics,
    PostAnalytics,
    AttendeeEventPreferences,
    MeetingsAnalytics,
    NotesAnalytics,
    MetricCard,
    ConnectionsAnalytics,
    SubEventAnalytics,
    AttendeeAnalytics,
    PartnersAnalytics,

  },
  props: {
    showDownloadButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      previewDialog: false
    }
  },
  computed: {
    ...mapGetters(["currentEvent"])
  },
  methods: {
    getDate() {
      const date = new Date();
      return `${date.getDate()} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`
    },
    formatDate(date) {
      const options = {day: 'numeric', month: 'short', year: 'numeric'};
      return date.toLocaleDateString('en-US', options);
    },
    displayDates() {
      const startDateTime = this.currentEvent.name.toLowerCase().includes('evoke') ? new Date("2024-2-7") : this.currentEvent.getEventActivationDateTime();
      const endDateTime = new Date(this.currentEvent.endDateTime);
      const startDateMinus14Days = new Date(startDateTime.getTime());
      startDateMinus14Days.setDate(startDateMinus14Days.getDate() - 14);
      const endDatePlus14Days = new Date(endDateTime.getTime());
      endDatePlus14Days.setDate(endDatePlus14Days.getDate() + 14);
      const startFormatted = this.formatDate(startDateMinus14Days);
      const endFormatted = this.formatDate(endDatePlus14Days);

      const startYear = startDateMinus14Days.getFullYear();
      const endYear = endDatePlus14Days.getFullYear();
      let date = '';
      if (startYear === endYear) {
        date = `${startFormatted.slice(0, -6)} - ${endFormatted}`;
      } else {
        date = `${startFormatted} - ${endFormatted}`;
      }
      return date;
    }
  }
}
</script>

<template>
  <div style="background-color: #F6F7FC" class="pa-12">
    <v-row class="ma-auto">
    <div >
      <span class="text-h4 font-weight-medium text--black">Analytics summary for {{this.currentEvent.name}}</span>
    </div>
      <v-spacer/>
      <div style="color: #516077" class="pt-1"> Reporting period:<br/>{{ this.displayDates() }}
      </div>
    </v-row>
    <v-row class="ma-auto">
        <span class="font-weight-medium text-h5 py-4">Highlights</span>
    </v-row>
    <div>
      <v-row>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Attendees"
              :value="currentEvent.analyticsData.allAtteneesCount"
              image="account-grey.png"
              tooltip-text="Total number of attendees who are still part of the event."
              :is-pdf="true"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Connections Made"
              :value="currentEvent.noOfConnections"
              image="account-group.png"
              :is-pdf="true"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Partner Profile Views"
              :value="currentEvent.analyticsData.totalPartnersProfileViews"
              image="cursor-click.png"
              :is-pdf="true"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Match Matching"
              :value="currentEvent.analyticsData.totalMatchMaking"
              image="account-switch.png"
              tooltip-text="Total number of attendees that completed their preferences to produce their list of Suggested Connections."
              :is-pdf="true"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Messages Sent"
              :value="currentEvent.analyticsData.totalMessagesSent"
              image="message-circle.png"
              :is-pdf="true"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Post Created"
              :value="currentEvent.analyticsData.totalPostCreated"
              image="post-add-grey.png"
              tooltip-text="Total number of posts created within the event newsfeed."
              :is-pdf="true"
          />
        </v-col>
      </v-row>
      <div class="pb-2 pt-12">
        <span class="font-weight-medium text-h5 ">All analytics</span>
      </div>
      <v-row>

        <v-col cols="12" md="12">
          <SubEventAnalytics :is-pdf="true" />
        </v-col>
        <v-col cols="12" >
          <AttendeeAnalytics :is-pdf="true"/>
        </v-col>
        <v-col cols="12" md="6" >
          <AttendeeEventPreferences :is-pdf="true" />
        </v-col>
        <v-col cols="12" md="6">
          <MessagingAnalytics :is-pdf="true" />
        </v-col>
        <v-col cols="12" md="6">
          <PartnersAnalytics :is-pdf="true" />
        </v-col>
        <v-col cols="12" md="6">
          <ConnectionsAnalytics :is-pdf="true" />
        </v-col>
        <v-col cols="12" md="6" class="mb-2" id="nextPage">
          <PostAnalytics :is-pdf="true"/>
        </v-col>
        <v-col cols="12" md="6" class="mb-2">
          <NotesAnalytics class="pb-5" :is-pdf="true"/>
          <MeetingsAnalytics :is-pdf="true"/>
        </v-col>
      </v-row>
    </div>
    <div style="color: #516077; font-weight: 400; font-size: 16px" class="pt-4">
      Report created: {{getDate()}}
    </div>
  </div>

</template>

<style scoped>
.row {
  display: flex;
}
</style>